import React from 'react';

import Grid from "@material-ui/core/Grid";

// src components
import IconLink from "../../../IconLink";

// src helpers
import {icons} from "./utils"
const HomeLinks = () => {
    return (
        <Grid container direction="row" justify="center" className="home-links">
            {icons.map(({to, icon, text, type, id}, index) => {
                return (
                    <Grid item xs={12} md={4} lg={2} key={index}>
                    <IconLink
                        id={id}
                        to={to}
                        type={type}
                        icon={icon}
                        testid={`MEDICAL_RX_${text.toUpperCase()}`}
                        text={text}
                        marginLeft='-40%'
                        height='80px'
                        width='80px'
                    />
                    </Grid>
                );
            })}
        </Grid>
    )
};
export default HomeLinks;
